import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createBoard({ commit }, data) {
      try {
        return await api.post('/params/boards', data)
      } catch (error) {
        throw error
      }
    },

    async getBoards({ commit }) {
      try {
        const response = await api.get('/params/boards')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getBoard({ commit }, id) {
      try {
        const response = await api.get(`/params/boards/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateBoard({ commit }, data) {
      try {
        return await api.put(`/params/boards/${data.id}`, data.board)
      } catch (error) {
        throw error
      }
    },

    async deleteBoard({ commit }, id) {
      try {
        return await api.delete(`/params/boards/${id}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
